import { render, staticRenderFns } from "./DetailCustomerSegment.vue?vue&type=template&id=24abea20&scoped=true"
import script from "./DetailCustomerSegment.vue?vue&type=script&lang=js"
export * from "./DetailCustomerSegment.vue?vue&type=script&lang=js"
import style0 from "./DetailCustomerSegment.vue?vue&type=style&index=0&id=24abea20&prod&lang=scss"
import style1 from "./DetailCustomerSegment.vue?vue&type=style&index=1&id=24abea20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24abea20",
  null
  
)

export default component.exports